import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

interface ExplainerStep {
  number: number;
  title: string;
  body: string;
}

/**
 * First-run state, shown when the brief has no Spark campaign yet.
 *
 * Derived from campaign count — there is no preview toggle, unlike the prototype.
 */
@Component({
  selector: 'sa-ads-empty-state',
  imports: [],
  templateUrl: './ads-empty-state.html',
  styleUrl: './ads-empty-state.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdsEmptyState {
  /** Number of cleared creator posts ready to carry budget, when known. */
  readonly clearedPostCount = input<number | undefined>(undefined);

  readonly createCampaign = output<void>();
  readonly browseVideos = output<void>();

  protected readonly steps: readonly ExplainerStep[] = [
    {
      number: 1,
      title: 'Set the goal',
      body: 'A campaign holds one objective and an optional spending cap. Takes about a minute.',
    },
    {
      number: 2,
      title: 'Choose the audience',
      body: 'One ad group, one audience, one budget. We show estimated reach as you go.',
    },
    {
      number: 3,
      title: 'Spark a creator post',
      body: 'Pick a cleared post from your library. No new creative to make, no codes to chase.',
    },
  ];

  protected onCreateCampaign(): void {
    this.createCampaign.emit();
  }

  protected onBrowseVideos(): void {
    this.browseVideos.emit();
  }
}
